export default {"src":"/_next/static/media/play-btn.ba7e135c.svg","height":54,"width":54,"blurWidth":0,"blurHeight":0};